import { useFlagBasedOnJSONDomain } from '@components/Flag';

export const useFacilityV2Flag = (): boolean => {
  return useFlagBasedOnJSONDomain('ME-35786-feat-facility-migration-v2');
};
